import { render, staticRenderFns } from "./LinkTenantSetting.vue?vue&type=template&id=13ff3962&scoped=true&"
import script from "./LinkTenantSetting.vue?vue&type=script&lang=js&"
export * from "./LinkTenantSetting.vue?vue&type=script&lang=js&"
import style0 from "./LinkTenantSetting.vue?vue&type=style&index=0&id=13ff3962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff3962",
  null
  
)

export default component.exports